import Plyr from 'plyr';

document.addEventListener('DOMContentLoaded', ()=>{

    const videoWrappers = document.querySelectorAll('._js-video-wrapper');

    let players = [];

    if (videoWrappers.length > 0) {

        videoWrappers.forEach(wrapper => {
            const videoPlayer = wrapper.querySelector('._js-video-player');
            if (!videoPlayer) return;

            const hasFullscreen = wrapper.classList.contains('_js-video-wrapper--fullscreen');

            const player = new Plyr(videoPlayer, {
                controls: ['play', 'progress', 'current-time', 'duration', 'mute', 'volume', 'settings', ...(hasFullscreen ? ['fullscreen'] : [])],
                fullscreen: { enabled: hasFullscreen },
                settings: []
            });

            players.push(player);

            const playButton = wrapper.querySelector('._js-play-button');
            if (playButton) {
                playButton.addEventListener('click', () => player.togglePlay());
            }

            player.on('ended', () => {
                player.elements.container.classList.add('plyr--stopped');
            });
        });

        // players = Plyr.setup('._js-video-player', {
        //     controls: ['play', 'progress', 'current-time', 'duration', 'mute', 'volume', 'settings'],
        //     fullscreen: {enabled: false},
        //     settings: []
        // });

        // players.forEach(player =>{
        //     const videoWrapper = player.elements.wrapper;
        //     const videoContainer = player.elements.container;
        //
        //     const videoWrapperParent = videoWrapper.closest('._js-video-wrapper');
        //
        //
        //     const playButton = videoWrapperParent.querySelector('._js-play-button');
        //     if (playButton){
        //         playButton.addEventListener('click',()=>{
        //             player.togglePlay();
        //         })
        //     }
        //
        //
        //     player.on('ended', ()=>{
        //         videoContainer.classList.add('plyr--stopped');
        //     })
        // })
    }



    const audio = Array.from(document.querySelectorAll('._js-audio')).map((p) => new Plyr(p, {
        controls: ['play', 'progress','mute', 'volume'],
    }));


    const allPlayers = [...players, ...audio];

    allPlayers.forEach(player => {
        player.on('play', () => {
            allPlayers.forEach(other => {
                if (other !== player) other.pause();
            });
        });
    });
})